import React, { useEffect } from 'react';
import ServicesTabs from './ServicesTabs';
import HeroSection from './HeroSection';
import Stats from './Stats';
import Services from './Services';
import MoreOverSection from './MoreOverSection';
import CTA from './CTA';
import useSeo from '../../hooks/useSeo';

const Homepage = () => {
    useEffect(() => {
        const url = 'https://wati-integration-prod-service.clare.ai/v2/watiWidget.js?56156';
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = url;

        script.onload = () => {
            if (window.CreateWhatsappChatWidget) {
                const options = {
                    enabled: true,
                    chatButtonSetting: {
                        backgroundColor: '#00e785',
                        ctaText: 'Chat with us',
                        borderRadius: '25',
                        marginLeft: '20',
                        marginRight: '0',
                        marginBottom: '20',
                        ctaIconWATI: true,
                        position: 'left',
                    },
                    brandSetting: {
                        brandName: 'ZATCA',
                        brandSubTitle: 'undefined',
                        brandImg: 'https://www.wati.io/wp-content/uploads/2023/04/Wati-logo.svg',
                        welcomeText: 'Hi there!\nHow can I help you?',
                        // messageText: 'Hello, %0A I have a question about {{ page_link }}',
                        backgroundColor: '#00e785',
                        ctaText: 'Chat with us',
                        borderRadius: '25',
                        autoShow: false,
                        phoneNumber: '+923117730410',
                    },
                };
                window.CreateWhatsappChatWidget(options);
            } else {
                console.error('CreateWhatsappChatWidget function is not available.');
            }
        };

        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(script, firstScript);

        return () => {
            script.remove();
        };
    }, []);


    useSeo({
        title: "Top Saudi Arabia E-Invoicing Solution | Top Zatca E-Invoicing - KSA",
        description: "Unlock the future of business in Saudi Arabia with our ZATCA-approved e-invoicing platform, optimized for seamless VAT compliance.",
        keywords: "ZATCA API, e-invoicing, compliance services, Saudi Arabia, invoice hashing, digital signing",
        canonical: "https://www.zatca.co",
        ogTitle: "ZATCA API – E-Invoicing & Compliance Services for Saudi Arabia",
        ogDescription: "API services for ZATCA compliance including e-invoicing, hashing, signing invoices, and more for Saudi businesses.",
        ogUrl: "https://www.zatca.co",
        ogType: "website"
    });

    return (
        <div className="px-0 md:mx-0">

            <HeroSection />
            <ServicesTabs />
            <Stats />
            <Services />
            <MoreOverSection />
            <CTA />
        </div>
    );
};

export default Homepage;
